import { Component, Input, trigger, state, transition, animate, style, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
    selector: 'lfwms-header-accordion',
    templateUrl: './lf-header-accordion.component.html',
    styleUrls: ['./lf-header-accordion.component.css'],
    animations: [
        trigger('tabContent', [
            state('hidden', style({
                height: '0'
            })),
            state('visible', style({
                height: '*'
            })),
            transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class HeaderAccordionComponent implements OnInit, OnChanges {

    @Input() expanded: boolean;
    @Input() header: { large: string, small: string };
    @Input() icon: string; // Accepts the icon path
    @Output() open: EventEmitter<boolean> = new EventEmitter();
    public isLoading: boolean = true;

    public ngOnInit() {
        this.isLoading = false;
    }

    public ngOnChanges() {
        
    }

    public toggleTab() {
        if (this.expanded) {
            this.open.emit(false);
            this.expanded = false;
        } else {
            this.open.emit(true);
            this.expanded = true;
        }
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/platform/lf-header-accordian/lf-header-accordion.component.ts